module.exports = __webpack_public_path__ + "media/mobile/icon-cancel--grey-aa5a72eb.svg";